angular.module('dealerware.web.data').factory('DealerwareRoleModel',function(Model) {

    var model = new Model({
        baseEndpoint: '/locations/:location_id/users/:employee_id/roles',
        actionOverrides: {
            post: {
                ignoreAssociations: true
            }
        }
    });

    return model;
});